import { Component } from '@theme/component';
import { morph, MORPH_OPTIONS } from '@theme/morph';
import { OverflowList } from '@theme/overflow-list';
import {
  yieldToMainThread,
  getViewParameterValue,
  ResizeNotifier,
} from '@theme/utilities';
import { ProductSelectEvent } from '@shopify/events';
export default class VariantPicker extends Component {
  #pendingRequestUrl;
  #abortController;
  #checkedIndices = [];
  #radios = [];
  #resizeObserver = new ResizeNotifier(() =>
    this.updateVariantPickerCss()
  );
  #isConnected = false;
  connectedCallback() {
    super.connectedCallback();
    this.#isConnected = true;
    const fieldsets =
      (this.refs.fieldsets || []);
    this.#radios = [];
    this.#checkedIndices = [];
    fieldsets.forEach((fieldset, fieldsetIndex) => {
      const radios = Array.from(
        fieldset.querySelectorAll(
          'input[type="radio"]'
        )
      );
      radios.forEach((radio, inputIndex) => {
        radio.dataset.fieldsetIndex =
          String(fieldsetIndex);
        radio.dataset.inputIndex =
          String(inputIndex);
      });
      this.#radios.push(radios);
      const initialCheckedIndex = radios.findIndex(
        (radio) =>
          radio.dataset.currentChecked === 'true' ||
          radio.checked
      );
      if (initialCheckedIndex !== -1) {
        this.#checkedIndices.push([
          initialCheckedIndex,
        ]);
      } else {
        this.#checkedIndices.push([]);
      }
    });
    this.addEventListener(
      'change',
      this.variantChanged.bind(this)
    );
    this.#resizeObserver.observe(this);
    requestAnimationFrame(() => {
      if (!this.#isConnected) return;
     const matchedVariant = this.syncVariantFromUrl();

if (!matchedVariant) {
  this.syncCurrentConnectedOption();
}

this.updateVariantPickerCss();
    });
  }
  disconnectedCallback() {
    this.#isConnected = false;
    super.disconnectedCallback();
    this.#resizeObserver.disconnect();
    this.#abortController?.abort();
    this.#abortController = undefined;
  }
  #normalizeProductUrl(value) {
    if (!value) return '';
    try {
      const url = new URL(
        value,
        window.location.origin
      );
      return (
        url.pathname
          .replace(/\/+$/, '')
          .toLowerCase() || '/'
      );
    } catch {
      return (
        String(value)
          .split('?')[0]
          .split('#')[0]
          .replace(/\/+$/, '')
          .toLowerCase() || '/'
      );
    }
  }
  #getOptionName(element) {
    if (!element) return '';
    const fieldset =
      element.closest('fieldset');
    const legend =
      fieldset?.querySelector('legend');
    const label =
      element.closest('label');
    const rawName =
      element.dataset?.optionName ||
      fieldset?.dataset?.optionName ||
      fieldset?.dataset?.option ||
      legend?.dataset?.optionName ||
      label?.dataset?.optionName ||
      '';
    return String(rawName)
      .replace(/\s*\*:\s*\*$/, '')
      .trim()
      .toLowerCase();
  }
  #getOptionType(element) {
    if (!element) return '';
    const normalized =
      this.#getOptionName(element);
    if (
      normalized === 'color' ||
      normalized === 'colour' ||
      normalized.includes('color') ||
      normalized.includes('colour')
    ) {
      return 'color';
    }
    if (
      normalized === 'gemstone' ||
      normalized === 'birthstone' ||
      normalized === 'stone color' ||
      normalized === 'stone colour' ||
      normalized === 'birth month' ||
      normalized.includes('gemstone') ||
      normalized.includes('birthstone')
    ) {
      return 'gemstone';
    }
    return '';
  }
  #getConnectedOptions() {
    return Array.from(
      this.querySelectorAll(
        'fieldset input[data-connected-product-url], select option[data-connected-product-url]'
      )
    );
  }
  #getCheckedOptionByType(optionType) {
    const checkedInputs = Array.from(
      this.querySelectorAll(
        'fieldset input[type="radio"]:checked'
      )
    );
    return (
      checkedInputs.find(
        (input) =>
          this.#getOptionType(input) === optionType
      ) || null
    );
  }
  #updateOptionValueLabel(element) {
    if (!element) return;
    const fieldset =
      element.closest('fieldset');
    if (!fieldset) return;
    const valueElement =
      fieldset.querySelector('.variant_option__swatch-value, .variant-option__swatch-value, [data-swatch-value], [data-option-value]');
    if (!valueElement) return;
    const label =
      element.closest('label');
    const value =
      element.value ||
      element.dataset?.optionValue ||
      label?.getAttribute('title') ||
      label?.textContent?.trim() ||
      '';
    if (value) {
      valueElement.textContent = value;
    }
  }
  #findConnectedOptionForCurrentProduct(optionType, currentPath) {
    const options = this.#getConnectedOptions().filter((option) => {
      if (this.#getOptionType(option) !== optionType) {
        return false;
      }
      const connectedUrl = this.#normalizeProductUrl(
        option.dataset.connectedProductUrl
      );
      return connectedUrl && connectedUrl === currentPath;
    });
    if (options.length === 1) {
      return options[0];
    }
    if (options.length > 1) {
      const checkedMatch = options.find((option) => {
        if (option instanceof HTMLInputElement) {
          return option.checked;
        }
        return option instanceof HTMLOptionElement && option.selected;
      });
      return checkedMatch || null;
    }
    return null;
  }

syncVariantFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const urlVariantId = params.get('variant');

  if (!urlVariantId) return false;

  const script = this.querySelector('script[type="application/json"]');
  if (!script) return false;

  let productData;

  try {
    productData = JSON.parse(script.textContent);
  } catch {
    return false;
  }

  const variants = Array.isArray(productData.variants)
    ? productData.variants
    : [];

  const matchedVariant = variants.find(
    (variant) => String(variant.id) === String(urlVariantId)
  );

  if (!matchedVariant || !Array.isArray(matchedVariant.options)) {
    console.warn('[CC URL VARIANT] Variant not found:', urlVariantId);
    return false;
  }

  const fieldsets = Array.from(this.querySelectorAll('fieldset'));

  matchedVariant.options.forEach((optionValue, index) => {
    const fieldset = fieldsets[index];
    if (!fieldset) return;

    const radios = Array.from(
      fieldset.querySelectorAll('input[type="radio"]')
    );

    const matchedRadio = radios.find(
      (radio) => radio.value === String(optionValue)
    );

    if (matchedRadio) {
      this.updateSelectedOption(matchedRadio);
      this.#updateOptionValueLabel(matchedRadio);
    }
  });

  console.log('[CC URL VARIANT MATCHED]', {
    variantId: matchedVariant.id,
    options: matchedVariant.options
  });

  return true;
}
  #selectInitialOption(
    option,
    optionType
  ) {
    if (!option) return;
    if (
      option instanceof HTMLInputElement
    ) {
      const fieldset =
        option.closest('fieldset');
      const fieldsetIndex =
        Number.parseInt(
          option.dataset.fieldsetIndex || '',
          10
        );
      const inputIndex =
        Number.parseInt(
          option.dataset.inputIndex || '',
          10
        );
      const radios = fieldset
        ? Array.from(
          fieldset.querySelectorAll(
            'input[type="radio"]'
          )
        )
        : [];
      radios.forEach((radio) => {
        if (
          this.#getOptionType(radio) !==
          optionType
        ) {
          return;
        }
        radio.checked = false;
        radio.removeAttribute('checked');
        radio.dataset.currentChecked = 'false';
        radio.dataset.previousChecked = 'false';
        const label = radio.closest('label');
        if (label) {
          label.removeAttribute('aria-selected');
          label.removeAttribute('aria-checked');
          label.classList.remove(
            'is-active',
            'selected',
            'active',
            'variant-option__button-label--active'
          );
        }
      });
      option.checked = true;
      option.setAttribute('checked', 'checked');
      option.dataset.currentChecked = 'true';
      option.dataset.previousChecked = 'false';
      const label = option.closest('label');
      if (label) {
        label.setAttribute('aria-selected', 'true');
        label.setAttribute('aria-checked', 'true');
        label.classList.add(
          'is-active',
          'selected',
          'active',
          'variant-option__button-label--active'
        );
      }
      this.#updateOptionValueLabel(option);
      if (
        !Number.isNaN(fieldsetIndex) &&
        !Number.isNaN(inputIndex)
      ) {
        if (!this.#checkedIndices[fieldsetIndex]) {
          this.#checkedIndices[fieldsetIndex] = [];
        }
        this.#checkedIndices[fieldsetIndex] = [inputIndex];
        this.updateFieldsetCss(fieldsetIndex);
      }
      return;
    }
    if (
      option instanceof HTMLOptionElement
    ) {
      const select = option.parentElement;
      if (!(select instanceof HTMLSelectElement)) {
        return;
      }
      select.value = option.value;
      for (const selectOption of select.options) {
        selectOption.removeAttribute('selected');
      }
      option.setAttribute('selected', 'selected');
      this.#updateOptionValueLabel(option);
    }
  }
  #setAddToCartLoading(isLoading) {
  const productComponent = this.closest('product-component');
  const scope = productComponent || document;

  const buttons = scope.querySelectorAll(
    'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"], product-form button[type="submit"], .product-form__submit'
  );

  buttons.forEach((button) => {
    button.classList.toggle('load', isLoading);

    if (isLoading) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  });
}
  variantChanged(event) {
    if (!(event.target instanceof HTMLElement)) return;
    const selectedOption = event.target instanceof HTMLSelectElement
      ? event.target.options[event.target.selectedIndex]
      : event.target;
    if (!(selectedOption instanceof HTMLInputElement || selectedOption instanceof HTMLOptionElement)) return;
    this.updateSelectedOption(event.target);
    this.#updateOptionValueLabel(selectedOption);
    
    const isOnProductPage = this.dataset.templateProductMatch === 'true' &&
      !event.target.closest('product-card') && !event.target.closest('quick-add-dialog');
    const connectedProductUrl = (selectedOption.dataset.connectedProductUrl || '').trim();
    const cleanConnectedProductUrl = this.#normalizeProductUrl(connectedProductUrl);
    const currentProductUrl = this.#normalizeProductUrl(this.dataset.productUrl || window.location.pathname);
    const hasConnectedProduct = cleanConnectedProductUrl !== '';
    const loadsNewProduct = isOnProductPage && hasConnectedProduct && cleanConnectedProductUrl !== currentProductUrl;

    const isNormalVariantSelection =
      isOnProductPage &&
      !hasConnectedProduct &&
      this.#getOptionType(selectedOption) === 'color';

    if (isNormalVariantSelection) {
      const variantId = selectedOption.dataset.variantId;

      if (variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);

        history.replaceState({}, '', url.toString());
      }

      this.updateSelectedOption(selectedOption);
      this.#updateOptionValueLabel(selectedOption);
    }

    if (isOnProductPage && !hasConnectedProduct && this.#getOptionType(selectedOption) === 'color') {
      console.warn('[CC COLOR] No connected product URL; using normal Shopify variant selection.', {
        value: selectedOption.value,
        optionValueId: selectedOption.dataset.optionValueId || '',
      });
    }
    const isOnFeaturedProductSection = Boolean(this.closest('featured-product-information'));
    const morphElementSelector = loadsNewProduct ? 'main' : isOnFeaturedProductSection ? 'featured-product-information' : undefined;
    const optionValueId = selectedOption.dataset.optionValueId || '';
    // Build the request before changing dataset.productUrl so connected-product detection stays correct.
    let requestUrl = this.buildRequestUrl(selectedOption);
    if (loadsNewProduct) {
      const targetUrl = new URL(connectedProductUrl, window.location.origin);
      targetUrl.searchParams.delete('_pos');
      targetUrl.searchParams.delete('_sid');
      targetUrl.searchParams.delete('_ss');
      const connectedVariantId = selectedOption.dataset.connectedProductVariantId || '';
      if (connectedVariantId) {
        targetUrl.searchParams.set('variant', String(connectedVariantId));
        const request = new URL(requestUrl, window.location.origin);
        request.searchParams.set('variant', String(connectedVariantId));
        requestUrl = request.pathname + request.search;
        document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
          input.value = String(connectedVariantId);
          input.setAttribute('value', String(connectedVariantId));
        });
      }
      history.replaceState({}, '', targetUrl.pathname + targetUrl.search);
      this.dataset.productUrl = cleanConnectedProductUrl;
      this.dataset.productHandle = targetUrl.pathname.split('/').filter(Boolean).pop() || this.dataset.productHandle || '';
    } else if (isOnProductPage) {
      const variantId = selectedOption.dataset.variantId || '';
      if (variantId) {
        const productComponent = this.closest('product-component');
        const variantInputs = productComponent
          ? productComponent.querySelectorAll('input[name="id"]')
          : document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
        variantInputs.forEach((input) => {
          input.value = String(variantId);
          input.setAttribute('value', String(variantId));
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variantId));
        history.replaceState({}, '', url.toString());
      }
    }
    this.#setAddToCartLoading(true);
    this.fetchUpdatedSection(requestUrl, morphElementSelector, optionValueId);
  }
  buildRequestUrl(
    selectedOption,
    source = null,
    sourceSelectedOptionsValues = []
  ) {
    const rawConnectedUrl = (
      selectedOption.dataset.connectedProductUrl || ''
    ).trim();
    const cleanConnectedUrl =
      this.#normalizeProductUrl(rawConnectedUrl);
    const currentUrl =
      this.#normalizeProductUrl(
        this.dataset.productUrl || window.location.pathname
      );
    const isNewProduct =
      cleanConnectedUrl !== '' &&
      cleanConnectedUrl !== currentUrl;
let productUrl;

if (isNewProduct) {
  productUrl = rawConnectedUrl;
} else {
  productUrl =
    this.dataset.productUrl ||
    window.location.pathname;
}


this.#pendingRequestUrl = productUrl;
    const params = [];
    const viewParamValue = getViewParameterValue();
    if (viewParamValue) {
      params.push(`view=${encodeURIComponent(viewParamValue)}`);
    }
    if (!isNewProduct) {
      if (this.selectedOptionsValues.length && !source) {
        params.push(
          `option_values=${this.selectedOptionsValues.join(',')}`
        );
      } else if (source === 'product-card') {
        if (this.selectedOptionsValues.length) {
          params.push(
            `option_values=${sourceSelectedOptionsValues.join(',')}`
          );
        } else {
          params.push(
            `option_values=${selectedOption.dataset.optionValueId || ''}`
          );
        }
      }
    }
    const SECTION_ID_MAP = {
      'quick-add-component': 'section-rendering-product-card',
      'swatches-variant-picker-component': 'section-rendering-product-card',
      'featured-product-information': this.closest(
        'featured-product-information'
      )?.id,
    };
    const closestSectionId = Object.keys(SECTION_ID_MAP).find((sectionId) =>
      this.closest(sectionId)
    );
    if (closestSectionId) {
      const cleanUrl = productUrl.split('?')[0];
      const sectionId = SECTION_ID_MAP[closestSectionId];
      return (
        `${cleanUrl}?section_id=${encodeURIComponent(sectionId || '')}` +
        `${params.length ?`&${params.join('&')}` : ''}`
      );
    }
    const separator = productUrl.includes('?') ? '&' : '?';
    return params.length
      ? `${productUrl}${separator}${params.join('&')}`
      : productUrl;
  }
  fetchUpdatedSection(
    requestUrl,
    morphElementSelector,
    optionValueId = ''
  ) {
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const controller = this.#abortController;
    const deferredEventPromise = ProductSelectEvent.createPromise();
    const selectedOptions = this.getAllSelectedOptions();
    this.dispatchEvent(
      new ProductSelectEvent({
        product: {
          id: this.dataset.productId || '',
          title: this.dataset.productTitle || '',
          handle: this.dataset.productHandle || '',
        },
        selectedOptions,
        detail: {
          optionValueId,
        },
        promise: deferredEventPromise.promise,
      })
    );
    const ccFetchStartedAt = performance.now();
    console.log('[CC FETCH START]', requestUrl);
    fetch(requestUrl, {
      signal: controller.signal,
      headers: {
        Accept: 'text/html',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Variant request failed: ${response.status}`
          );
        }
        return response.text();
      })
      .then((responseText) => {
        if (controller !== this.#abortController) {
          return;
        }
        this.#pendingRequestUrl = undefined;
        const html = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );
        html
          .querySelector('overflow-list[defer]')
          ?.removeAttribute('defer');
        const variantPickerJsonScript = html.querySelector(
          'variant-picker script[type="application/json"]'
        );
        const textContent = variantPickerJsonScript?.textContent;
        let newProduct;
        if (morphElementSelector === 'main') {
          this.updateMain(html);
        }
        else if (morphElementSelector) {
          this.updateElement(html, morphElementSelector);
        }
        else {
          const { overflowList } = this.refs;
          const wasSwatchesExpanded =
            overflowList instanceof OverflowList &&
            overflowList.getAttribute('disabled') === 'true';
          newProduct = this.updateVariantPicker(html);
          if (wasSwatchesExpanded) {
            const overflowListAfterMorph = this.refs.overflowList;
            if (overflowListAfterMorph instanceof OverflowList) {
              overflowListAfterMorph.showAll();
            }
          }
        }
        requestAnimationFrame(() => {
if (!this.#isConnected) return;

const matchedVariant = this.syncVariantFromUrl();

if (!matchedVariant) {
this.syncCurrentConnectedOption();
}

this.updateVariantPickerCss();
});
        if (this.selectedOptionId && textContent) {
          let variantData;
          try {
            variantData = JSON.parse(textContent);
          } catch {
            variantData = null;
          }
          if (variantData && typeof variantData === 'object') {
            const productViewAttr = variantPickerJsonScript
              ?.closest('[view-event-payload]')
              ?.getAttribute('view-event-payload')
              ?.trim();
            let viewPayload = null;
            if (productViewAttr) {
              try {
                viewPayload = JSON.parse(productViewAttr);
              } catch {
                viewPayload = null;
              }
            }
            const selectedVariant = viewPayload?.product?.selectedVariant;
            const selectedVariantId = selectedVariant?.id;
            if (selectedVariantId) {
              const productComponent = this.closest('product-component');
              const variantInputs = productComponent
                ? productComponent.querySelectorAll('input[name="id"]')
                : [];
              variantInputs.forEach((input) => {
                input.value = String(selectedVariantId);
                input.setAttribute('value', String(selectedVariantId));
              });
              const url = new URL(window.location.href);
              url.searchParams.set('variant', String(selectedVariantId));
              history.replaceState({}, '', url.toString());
            }
            this.#setAddToCartLoading(false);
            deferredEventPromise.resolve({
              variant:
                viewPayload?.product?.selectedVariant || null,
              detail: {
                html,
                productId: this.dataset.productId || '',
                newProduct,
                sourceId: this.selectedOptionId,
                resource: variantData,
              },
            });
            return;
          }
        }
        this.#setAddToCartLoading(false);
        deferredEventPromise.resolve({
          variant: null,
          detail: {
            html,
            productId: this.dataset.productId || '',
            newProduct,
            sourceId: this.selectedOptionId,
            resource: null,
          },
        });
      })
      .catch((error) => {
        if (error?.name === 'AbortError') {
          console.warn('[CC] Previous variant fetch aborted');
          return;
        }
        this.#setAddToCartLoading(false);
        console.error('[CC] Variant fetch error:', error);
        deferredEventPromise.reject(error);
      });
  }
  updateVariantPicker(newHtml) {
    let newProduct;
    const newVariantPickerSource = newHtml.querySelector(
      this.tagName.toLowerCase()
    );
    if (!newVariantPickerSource) {
      throw new Error('No new variant picker source found');
    }
    if (newVariantPickerSource instanceof HTMLElement) {
      const newProductId = newVariantPickerSource.dataset.productId;
      const newProductUrl = newVariantPickerSource.dataset.productUrl;
      if (
        newProductId &&
        newProductUrl &&
        this.dataset.productId !== newProductId
      ) {
        newProduct = {
          id: newProductId,
          url: newProductUrl,
        };
      }
      if (newProductId) {
        this.dataset.productId = newProductId;
      }
      if (newProductUrl) {
        this.dataset.productUrl = newProductUrl;
      }
    }
    morph(this, newVariantPickerSource, {
      ...MORPH_OPTIONS,
      getNodeKey: (node) => {
        if (!(node instanceof HTMLElement)) {
          return undefined;
        }
        return node.dataset.key;
      },
    });
    this.#rebuildRadioReferences();
    this.updateVariantPickerCss();
    return newProduct;
  }
  #rebuildRadioReferences() {
    const fieldsets =
      (this.refs.fieldsets || []);
    this.#radios = [];
    this.#checkedIndices = [];
    fieldsets.forEach((fieldset, fieldsetIndex) => {
      const radios = Array.from(
        fieldset.querySelectorAll('input[type="radio"]')
      );
      radios.forEach((radio, inputIndex) => {
        radio.dataset.fieldsetIndex = String(fieldsetIndex);
        radio.dataset.inputIndex = String(inputIndex);
      });
      this.#radios.push(radios);
      const checkedIndex = radios.findIndex(
        (radio) =>
          radio.checked ||
          radio.dataset.currentChecked === 'true'
      );
      this.#checkedIndices.push(
        checkedIndex !== -1 ? [checkedIndex] : []
      );
    });
  }
  updateVariantPickerCss() {
    const fieldsets =
      (this.refs.fieldsets || []);
    const measurements = fieldsets
      .map((_, index) => this.#getFieldsetMeasurements(index))
      .filter((measurement) => measurement !== null);
    for (const measurement of measurements) {
      this.#applyFieldsetMeasurements(measurement);
    }
  }
  updateElement(newHtml, elementSelector) {
    const element = this.closest(elementSelector);
    const newElement = newHtml.querySelector(elementSelector);
    if (!element || !newElement) {
      throw new Error(
        `No new element source found for ${elementSelector}`
      );
    }
    morph(element, newElement);
  }
  updateMain(newHtml) {
    const main = document.querySelector('main');
    const newMain = newHtml.querySelector('main');
    if (!main || !newMain) {
      if (this.#pendingRequestUrl) {
        window.location.href = this.#pendingRequestUrl;
      }
      return;
    }
    const newTitle = newHtml.querySelector('title')?.textContent;
    if (newTitle) {
      document.title = newTitle;
    }
    morph(main, newMain);
  }
  #getFieldsetMeasurements(fieldsetIndex) {
    const fieldsets =
      (this.refs.fieldsets || []);
    const fieldset = fieldsets[fieldsetIndex];
    const checkedIndices = this.#checkedIndices[fieldsetIndex];
    const radios = this.#radios[fieldsetIndex];
    if (!radios || !checkedIndices || !fieldset) {
      return null;
    }
    const [currentIndex, previousIndex] = checkedIndices;
    return {
      fieldset,
      currentIndex,
      previousIndex,
      currentWidth:
        currentIndex !== undefined
          ? radios[currentIndex]?.parentElement?.offsetWidth
          : undefined,
      previousWidth:
        previousIndex !== undefined
          ? radios[previousIndex]?.parentElement?.offsetWidth
          : undefined,
    };
  }
  #applyFieldsetMeasurements({
    fieldset,
    currentWidth,
    previousWidth,
    currentIndex,
    previousIndex,
  }) {
    if (currentWidth) {
      fieldset.style.setProperty(
        '--pill-width-current',
        `${currentWidth}px`
      );
    } else if (currentIndex !== undefined) {
      fieldset.style.removeProperty('--pill-width-current');
    }
    if (previousWidth) {
      fieldset.style.setProperty(
        '--pill-width-previous',
        `${previousWidth}px`
      );
    } else if (previousIndex !== undefined) {
      fieldset.style.removeProperty('--pill-width-previous');
    }
  }
  updateFieldsetCss(fieldsetIndex) {
    if (Number.isNaN(fieldsetIndex)) {
      return;
    }
    const measurements =
      this.#getFieldsetMeasurements(fieldsetIndex);
    if (measurements) {
      this.#applyFieldsetMeasurements(measurements);
    }
  }
  updateSelectedOption(target) {
    if (typeof target === 'string') {
      const targetElement = this.querySelector(
        `[data-option-value-id="${target}"]`
      );
      if (!targetElement) {
        throw new Error('Target element not found');
      }
      target = targetElement;
    }
    if (target instanceof HTMLInputElement) {
      const fieldsetIndex = Number.parseInt(
        target.dataset.fieldsetIndex || '',
        10
      );
      const inputIndex = Number.parseInt(
        target.dataset.inputIndex || '',
        10
      );
      const fieldset = target.closest('fieldset');
      if (fieldset) {
        const labels = fieldset.querySelectorAll('label');
        labels.forEach((label) => {
          label.classList.remove(
            'is-active',
            'selected',
            'active',
            'variant-option__button-label--active'
          );
          label.removeAttribute('aria-selected');
          label.removeAttribute('aria-checked');
        });
        const activeLabel = target.closest('label');
        if (activeLabel) {
          activeLabel.classList.add(
            'is-active',
            'selected',
            'active',
            'variant-option__button-label--active'
          );
          activeLabel.setAttribute('aria-selected', 'true');
          activeLabel.setAttribute('aria-checked', 'true');
        }
      }
      this.#updateOptionValueLabel(target);
      if (
        !Number.isNaN(fieldsetIndex) &&
        !Number.isNaN(inputIndex)
      ) {
        const fieldsets =
          (this.refs.fieldsets || []);
        const fieldsetEl = fieldsets[fieldsetIndex];
        const checkedIndices = this.#checkedIndices[fieldsetIndex];
        const radios = this.#radios[fieldsetIndex];
        if (radios && checkedIndices && fieldsetEl) {
          const [currentIndex, previousIndex] = checkedIndices;
          if (
            currentIndex !== undefined &&
            radios[currentIndex]
          ) {
            radios[currentIndex].dataset.previousChecked = 'false';
          }
          if (
            previousIndex !== undefined &&
            radios[previousIndex]
          ) {
            radios[previousIndex].dataset.previousChecked = 'false';
          }
          if (checkedIndices[0] !== inputIndex) {
            checkedIndices.unshift(inputIndex);
          }
          checkedIndices.length = Math.min(
            checkedIndices.length,
            2
          );
          const newCurrentIndex = checkedIndices[0];
          const newPreviousIndex = checkedIndices[1];
          if (
            newCurrentIndex !== undefined &&
            radios[newCurrentIndex]
          ) {
            radios[newCurrentIndex].dataset.currentChecked = 'true';
            radios[newCurrentIndex].dataset.previousChecked = 'false';
          }
          if (
            newPreviousIndex !== undefined &&
            radios[newPreviousIndex]
          ) {
            radios[newPreviousIndex].dataset.previousChecked = 'true';
            radios[newPreviousIndex].dataset.currentChecked = 'false';
          }
          this.updateFieldsetCss(fieldsetIndex);
        }
      }
      target.checked = true;
      target.setAttribute('checked', 'checked');
      target.dataset.currentChecked = 'true';
      return;
    }
    if (target instanceof HTMLSelectElement) {
      const newValue = target.value;
      const newSelectedOption = Array.from(target.options).find(
        (option) => option.value === newValue
      );
      if (!newSelectedOption) {
        throw new Error('Option not found');
      }
      for (const option of target.options) {
        option.removeAttribute('selected');
      }
      newSelectedOption.setAttribute('selected', 'selected');
      this.#updateOptionValueLabel(newSelectedOption);
    }
  }
  get selectedOption() {
    const checkedInput = this.querySelector(
      'fieldset input[type="radio"]:checked'
    );
    if (checkedInput instanceof HTMLInputElement) {
      return checkedInput;
    }
    const selectedOption = this.querySelector(
      'select option:checked'
    );
    if (selectedOption instanceof HTMLOptionElement) {
      return selectedOption;
    }
    return undefined;
  }
  getAllSelectedOptions() {
    const options = [];
    for (const select of this.querySelectorAll('select')) {
      const selected = select.selectedOptions[0];
      if (!selected) {
        continue;
      }
      const name =
        selected.dataset?.optionName ||
        select.dataset?.optionName ||
        select.closest('fieldset')?.dataset?.optionName ||
        '';
      if (name) {
        options.push({
          name,
          value: selected.value,
        });
      }
    }
    const checkedInputs = this.querySelectorAll(
      'fieldset input[type="radio"]:checked'
    );
    for (const input of checkedInputs) {
      const name =
        input.dataset?.optionName ||
        input.closest('fieldset')?.dataset?.optionName ||
        '';
      if (name) {
        options.push({
          name,
          value: input.value,
        });
      }
    }
    return options;
  }
  get selectedOptionId() {
    const { selectedOption } = this;
    if (!selectedOption) {
      return undefined;
    }
    const { optionValueId } = selectedOption.dataset;
    if (!optionValueId) {
      console.warn('[CC] No option value ID found', selectedOption);
      return undefined;
    }
    return optionValueId;
  }
  get selectedOptionsValues() {
    const selectedOptions = Array.from(
      this.querySelectorAll(
        `
        select option:checked,
        fieldset input[type="radio"]:checked
        `
      )
    );
    return selectedOptions
      .map((option) => {
        const { optionValueId } = option.dataset;
        return optionValueId;
      })
      .filter(Boolean);
  }
}
if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}

